import React, { lazy, useContext } from "react";
import styled from "styled-components";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import context
import { StoreContext } from "./context/store";
// import components
import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";
// import Footer from "./components/Footer";
// import pages
import Home from "./pages/Home";
import Applications from "./pages/Applications";
import NotFound from "./pages/NotFound";
// import constants
import CONSTANTS from "./utils/constants/constants";
import SuspenseWrapper from "./common-components/SuspenseWrapper";

const { HOME, ABOUT_US, APPLICATIONS, TECHNOLOGY, BLOG, CONTACT_US } =
  CONSTANTS.LINKS;

// lazy-loaded pages
// const Home = lazy(() => import("./pages/Home"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
// const Applications = lazy(() => import("./pages/Applications"));
const Blogs = lazy(() => import("./pages/Blogs"));
const BlogPage = lazy(() => import("./pages/Blogs/BlogPage"));
const SAR = lazy(() => import("./pages/Technologies/SAR"));
const GPR = lazy(() => import("./pages/Technologies/GPR"));
const Hyperspectral = lazy(() => import("./pages/Technologies/Hyperspectral"));
const OtherTechs = lazy(() => import("./pages/Technologies/Others"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const Footer = lazy(() => import("./components/Footer"));

const Main = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100vw;
  max-width: 100%;
  height: auto;
  min-height: 100vh;
  background-color: #000;
`;

const ContentWrapper = styled.div`
  flex: 1;
  width: 100vw;
  max-width: 100%;
  min-height: 100vh;
`;

function App() {
  const { state } = useContext(StoreContext);
  const { isPageValid } = state;

  return (
    <Router>
      <Main className="main-app-wrapper">
        <ScrollToTop />
        {isPageValid && <Navbar />}
        <ContentWrapper>
          <Routes>
            <Route path={HOME.LINK} element={<Home />} />
            <Route
              path={ABOUT_US.LINK}
              element={
                <SuspenseWrapper>
                  <AboutUs />
                </SuspenseWrapper>
              }
            />
            <Route path={APPLICATIONS.LINK} element={<Applications />} />
            <Route
              path={TECHNOLOGY.PAGES[0].LINK}
              element={
                <SuspenseWrapper>
                  <SAR />
                </SuspenseWrapper>
              }
            />
            <Route
              path={TECHNOLOGY.PAGES[1].LINK}
              element={
                <SuspenseWrapper>
                  <GPR />
                </SuspenseWrapper>
              }
            />
            <Route
              path={TECHNOLOGY.PAGES[2].LINK}
              element={
                <SuspenseWrapper>
                  <Hyperspectral />
                </SuspenseWrapper>
              }
            />
            <Route
              path={TECHNOLOGY.PAGES[3].LINK}
              element={
                <SuspenseWrapper>
                  <OtherTechs />
                </SuspenseWrapper>
              }
            />
            <Route
              path={BLOG.LINK}
              element={
                <SuspenseWrapper>
                  <Blogs />
                </SuspenseWrapper>
              }
            />
            <Route
              path="/blog/:slug/:slug1"
              element={
                <SuspenseWrapper>
                  <BlogPage />
                </SuspenseWrapper>
              }
            />
            <Route
              path={CONTACT_US.LINK}
              element={
                <SuspenseWrapper>
                  <ContactUs />
                </SuspenseWrapper>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ContentWrapper>
        {isPageValid && (
          <SuspenseWrapper>
            <Footer />
          </SuspenseWrapper>
        )}
      </Main>
    </Router>
  );
}

export default App;
